/**
 * Created by tayloremolo on 11/4/17.
 */
import React, {Component} from 'react';
import ReactDOM from "react-dom";

class TransformationSection extends Component {
    // constructor() {
    //     super();
    //
    // }
    // componentDidMount(){
    //     });
    // }

    render() {

        return (
            <div>
                <div className="section-8-et block-4 z-17 pb-40">
                    <div className="container relative-text p-40">
                        <div className="row m0 p-20">
                            <div className="col s12 p0 center-align">
                                <h1 className="f-32 ls-1 white-text bold-text text-uppercase">Take ownership is for anyone who wants <br/><span className="f-52 ls-1">Transformational Results.</span> </h1>
                            </div>
                        </div>
                        <div className="row m0">
                            <div className="col s11 offset-s1 m11 offset-m1 l11 offset-l1 p0 center-align">
                                <div className="col s12 m6 l6 p0 center-align">
                                    <div className="col s1 m1 left-align p0"><i className="fa fa-check f-18 white-text white-border-all" aria-hidden="true" /></div>
                                    <div className="col s11 m11 left-align">
                                        <p className="white-text f-22 m0 pb-8 bold-text text-uppercase">Young Professionals</p>
                                        <br/>
                                    </div>
                                    <div className="col s1 m1 left-align p0"><i className="fa fa-check f-18 white-text white-border-all" aria-hidden="true" /></div>
                                    <div className="col s11 m11 left-align">
                                        <p className="white-text f-22 m0 pb-8 bold-text text-uppercase">Entrepreneurs</p>
                                        <br/>
                                    </div>
                                    <div className="col s1 m1 left-align p0"><i className="fa fa-check f-18 white-text white-border-all" aria-hidden="true" /></div>
                                    <div className="col s11 m11 left-align">
                                        <p className="white-text f-22 m0 pb-8 bold-text text-uppercase">Executives</p>
                                        <br/>
                                    </div>
                                    <div className="col s1 m1 left-align p0"><i className="fa fa-check f-18 white-text white-border-all" aria-hidden="true" /></div>
                                    <div className="col s11 m11 left-align">
                                        <p className="white-text f-22 m0 pb-8 bold-text text-uppercase">Intrapreneurs</p>
                                        <br/>
                                    </div>
                                </div>
                                <div className="col s12 m6 l6 p0 center-align">
                                    <div className="col s1 m1 left-align p0"><i className="fa fa-check f-18 white-text white-border-all" aria-hidden="true" /></div>
                                    <div className="col s11 m11 left-align">
                                        <p className="white-text f-22 m0 pb-8 bold-text text-uppercase">Freelancers</p>
                                        <br/>
                                    </div>
                                    <div className="col s1 m1 left-align p0"><i className="fa fa-check f-18 white-text white-border-all" aria-hidden="true" /></div>
                                    <div className="col s11 m11 left-align">
                                        <p className="white-text f-22 m0 pb-8 bold-text text-uppercase">Sales Teams</p>
                                        <br/>
                                    </div>
                                    <div className="col s1 m1 left-align p0"><i className="fa fa-check f-18 white-text white-border-all" aria-hidden="true" /></div>
                                    <div className="col s11 m11 left-align">
                                        <p className="white-text f-22 m0 pb-8 bold-text text-uppercase">Businesses</p>
                                        <br/>
                                    </div>
                                    <div className="col s1 m1 left-align p0"><i className="fa fa-check f-18 white-text white-border-all" aria-hidden="true" /></div>
                                    <div className="col s11 m11 left-align">
                                        <p className="white-text f-22 m0 pb-8 bold-text text-uppercase">Coaches & Consultants</p>
                                        <br/>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        )

    }

}

export default TransformationSection;


// WEBPACK FOOTER //
// ./src/components/transformation-section.js